import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config/apiBase';
import { getTenantId, subscribeTenant } from '../services/bakingApi';
import { subscribeJobStream } from '../services/jobStream';

const API_BASE = API_BASE_URL;

// One connection per page; refreshes are triggered by changes, never a browser timer.
export default function useJobStream({ jobId, projectId, rigging = false, enabled = true } = {}) {
  const [tenantId, setTenant] = useState(getTenantId);
  const [revision, setRevision] = useState(0);
  const [status, setStatus] = useState('connecting');
  useEffect(() => subscribeTenant((next) => setTenant(next)), []);
  useEffect(() => {
    if (!enabled || typeof ReadableStream === 'undefined' || typeof fetch === 'undefined') {
      setStatus('unavailable');
      return undefined;
    }
    let pending;
    const refresh = () => {
      if (!pending) pending = setTimeout(() => { pending = null; setRevision((n) => n + 1); }, 150);
    };
    const query = new URLSearchParams();
    if (rigging) query.set('kind', 'rigging');
    if (projectId) query.set('project_id', projectId);
    const path = jobId ? `/bake-jobs/${jobId}/stream/` : '/bake-jobs/stream/';
    const stop = subscribeJobStream(`${API_BASE}/v1${path}?${query}`, {
      tenantId,
      onStatus: (next) => {
        setStatus(next);
        if (next === 'live') refresh();
      },
      onChange: () => {
        // Coalesce event bursts without delaying them indefinitely.
        refresh();
      },
    });
    return () => { clearTimeout(pending); stop(); };
  }, [jobId, projectId, rigging, enabled, tenantId]);
  return { revision, status };
}
